(() => {
'use strict';
const $=s=>document.querySelector(s), $$=s=>[...document.querySelectorAll(s)];
const configElement=$('#azhar-config');
if(!configElement){console.warn('[Al Azhar] #azhar-config introuvable : le script ne démarre pas.');return;}
const theme=JSON.parse(configElement.dataset.config);
// Valeur par défaut false dans les paramètres du thème Shopify.
const SERUM_EN_VENTE = theme.serumEnabled === true;
const reduced=()=>matchMedia('(prefers-reduced-motion: reduce)').matches;
const scrollTo=el=>el?.scrollIntoView({behavior:reduced()?'instant':'smooth',block:'start'});
let active='oriental',qty=1,view='ambiance';
 const catalog={
  oriental:{id:'oriental',family:'oil',title:'Huile à brûler parfumée',variant:'Oriental',image:theme.assets.oil,other:theme.assets.water,price:2490},
  orange:{id:'orange',family:'oil',title:'Huile à brûler parfumée',variant:'Fleur d’oranger',image:theme.assets.orange,other:null,price:2490},
  serum:{id:'serum',family:'care',title:'Élixir royal de jeunesse',variant:'Élixir royal de jeunesse',image:theme.assets.serum,other:null,price:null}
 };

for(const id of Object.keys(catalog)){Object.assign(catalog[id],theme.products[id]);if(id==='serum'&&!SERUM_EN_VENTE)catalog[id].available=false;}
// Le panier Shopify est l’unique source des lignes, prix, remises et totaux.
let cart = { items: [], item_count: 0, total_price: 0 }, busy = false, loaded = false, removed = null;
const money = cents => new Intl.NumberFormat('fr-FR', {style:'currency',currency:theme.currency || 'EUR'}).format(cents/100);
const amount = (id, quantity=1) => Number.isSafeInteger(catalog[id].price) ? money(catalog[id].price*quantity) : '[À COMPLÉTER]';
const el=(tag,cls,text)=>{const n=document.createElement(tag);if(cls)n.className=cls;if(text!==undefined)n.textContent=text;return n;};
function renderCatalogPrice(node, id, suffix = ' TTC') {
  const p = catalog[id];
  node.replaceChildren();

  if (
    !p ||
    !p.productId ||
    !p.variantId ||
    !Number.isSafeInteger(p.price) ||
    p.price < 0
  ) {
    node.textContent = 'Prix indisponible';
    return;
  }

  const hasReduction =
    Number.isSafeInteger(p.compareAtPrice) &&
    p.compareAtPrice > p.price;

  if (theme.showComparePrices === true && hasReduction) {
    const oldPrice = el(
      's',
      'az-price-before',
      money(p.compareAtPrice)
    );

    oldPrice.setAttribute(
      'aria-label',
      'Prix avant réduction : ' + money(p.compareAtPrice)
    );

    node.append(oldPrice, document.createTextNode(' '));
  }

  node.append(
    el('span', 'az-price-current', money(p.price) + suffix)
  );

  if (theme.showLaunchLabel === true && hasReduction) {
    node.append(
      document.createTextNode(' '),
      el('span', 'az-launch-label', 'Prix de lancement')
    );
  }
}
const root=theme.root.endsWith('/')?theme.root:theme.root+'/';
const dialogs={product:$('#product-dialog'),cart:$('#cart-dialog')};
const lock=()=>document.body.classList.toggle('dialog-open',$$('dialog').some(d=>d.open));
function show(name){Object.values(dialogs).forEach(d=>{if(d.open)d.close();});dialogs[name].showModal();lock();}
function close(name){dialogs[name].close();lock();}
function announce(text){const region=$('dialog[open] .dialog-status')||$('.az-status');if(region)region.textContent=text;}
Object.entries(dialogs).forEach(([name,d])=>{d.addEventListener('close',lock);d.addEventListener('click',e=>{if(e.target!==d)return;const r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)close(name);});});
$$('[data-close]').forEach(b=>b.addEventListener('click',()=>close(b.dataset.close)));
function setBusy(value){busy=value;$('.cart-items').setAttribute('aria-busy',String(value));$$('#cart-dialog button:not([data-close]),#cart-dialog select,#product-add').forEach(b=>{if(value){b.dataset.wasDisabled=String(b.disabled);b.disabled=true;}else if('wasDisabled'in b.dataset){b.disabled=b.dataset.wasDisabled==='true';delete b.dataset.wasDisabled;}});}
async function request(endpoint,body){
 const response=await fetch(root+endpoint,{method:body?'POST':'GET',credentials:'same-origin',cache:'no-store',headers:{'Accept':'application/json',...(body?{'Content-Type':'application/json'}:{})},...(body?{body:JSON.stringify(body)}:{})});
 const data=await response.json();
 if(!response.ok||data.status>=400)throw new Error(typeof data.description==='string'?data.description:typeof data.message==='string'?data.message:'Impossible de mettre à jour le panier.');
 return data;
}
function error(message){$('.cart-error').textContent=message;$('.cart-error').hidden=false;announce(message);}
async function refresh(){const data=await request('cart.js');if(!Array.isArray(data.items)||!Number.isSafeInteger(data.total_price))throw new Error('Le panier n’a pas pu être chargé.');cart=data;loaded=true;theme.currency=data.currency||theme.currency;renderCart();}
async function mutate(action,message,after){
 if(busy)return;setBusy(true);$('.cart-error').hidden=true;
 try{await action();await refresh();if(after)after();announce(typeof message==='function'?message():message);return true;}
 catch(e){try{await refresh();}catch{loaded=false;}error((e instanceof TypeError?'Connexion interrompue. Vérifiez votre panier avant de réessayer.':e.message)+' Vous pouvez aussi ouvrir la page panier.');return false;}
 finally{setBusy(false);updateCheckout();}
}
async function add(id,quantity=1){
 const p=catalog[id];if(!p||!p.available||!p.variantId||(id==='serum'&&!SERUM_EN_VENTE)||!Number.isInteger(quantity)||quantity<1||quantity>99)return;
 const existing=cart.items.filter(i=>i.variant_id===p.variantId).reduce((sum,i)=>sum+i.quantity,0);
 if(existing+quantity>99){announce('Maximum 99 unités par produit.');return;}
 await mutate(()=>request('cart/add.js',{items:[{id:p.variantId,quantity}]}),p.variant+' ajouté au panier.',()=>{removed=null;$('.cart-undo').hidden=true;show('cart');});
}
function focusLine(key,preferred){if(!dialogs.cart.open)return;const row=$$('.cart-item').find(n=>n.dataset.key===key);const next=row?.querySelector(preferred+':not(:disabled)')||row?.querySelector('button:not(:disabled)')||$('#cart-title');next?.focus();}
async function changeQuantity(item,delta){
 const quantity=item.quantity+delta;if(quantity<1||quantity>99)return;
 await mutate(()=>request('cart/change.js',{id:item.key,quantity}),()=>{const current=cart.items.find(i=>i.key===item.key);return 'Quantité : '+(current?.quantity||0)+'. Total hors livraison : '+money(cart.total_price)+'.';},()=>focusLine(item.key,delta>0?'.quantity-plus':'.quantity-minus'));
}
async function remove(item){await mutate(()=>request('cart/change.js',{id:item.key,quantity:0}),'Article retiré.',()=>{removed={variantId:item.variant_id,quantity:item.quantity,properties:item.properties||{},sellingPlan:item.selling_plan_allocation?.selling_plan?.id};$('.cart-undo').hidden=false;$('#undo-remove').focus();});}
async function changeVariant(item,id){
 const replacement=catalog[id];if(!replacement?.available||item.variant_id===replacement.variantId)return;
 const existing=cart.items.find(i=>i.variant_id===replacement.variantId&&!i.selling_plan_allocation&&Object.keys(i.properties||{}).length===0);
 const quantity=item.quantity+(existing?.quantity||0);
 if(quantity>99){renderCart();announce('Le changement dépasse la limite de 99 unités. Les quantités ont été conservées.');return;}
 await mutate(()=>request('cart/update.js',{updates:{[item.key]:0,[existing?existing.key:String(replacement.variantId)]:quantity}}),'Parfum mis à jour.',()=>{removed=null;const next=cart.items.find(i=>i.variant_id===replacement.variantId);if(next)focusLine(next.key,'select');});
}
function updateCheckout(){
 const blocked=!SERUM_EN_VENTE&&cart.items.some(item=>item.variant_id===catalog.serum.variantId||(catalog.serum.productId&&item.product_id===catalog.serum.productId));
 $('#checkout-button').disabled=busy||!loaded||cart.item_count===0||blocked;
 $('.cart-availability').hidden=!blocked;
}
function renderCart(){
 const n=cart.item_count;$('.az-count').textContent=n;$('.az-selection-button').setAttribute('aria-label',`Ouvrir le panier, ${n} article${n>1?'s':''}`);
 $('.cart-item-count').textContent=n+' article'+(n>1?'s':'');$('.checkout-count').textContent=n+' article'+(n>1?'s':'');
 $('.cart-empty').hidden=n>0;$('.cart-summary').hidden=n===0;$('.cart-undo').hidden=!removed;
 const list=$('.cart-items');list.replaceChildren();
 for(const item of cart.items){
  const id=Object.keys(catalog).find(key=>catalog[key].variantId===item.variant_id),p=id?catalog[id]:null;
  const li=el('li','cart-item');li.dataset.key=item.key;
  const img=el('img','cart-item-image');img.src=p?.image||item.image||theme.assets.oil;img.alt=p?.variant||item.product_title;
  const content=el('div','cart-item-content'),heading=el('div','cart-item-heading');
  heading.append(el('h3','',p?.title||item.product_title),el('span','item-price',money(item.final_line_price)));
  const variant=el('div','item-variant');
  if(p?.family==='oil'&&!item.selling_plan_allocation&&Object.keys(item.properties||{}).length===0){
   const select=el('select');select.setAttribute('aria-label','Parfum de l’huile à brûler');
   for(const key of ['oriental','orange']){const option=el('option','',catalog[key].variant);option.value=key;option.selected=key===id;option.disabled=!catalog[key].available;select.append(option);}
   select.addEventListener('change',()=>changeVariant(item,select.value));variant.append(select);
  }else variant.textContent=p?.variant||(item.variant_title==='Default Title'?'':item.variant_title||'');
  const controls=el('div','item-controls'),counter=el('div','quantity-control'),minus=el('button','quantity-minus','−'),output=el('output','',String(item.quantity)),plus=el('button','quantity-plus','+'),removeButton=el('button','item-remove','Retirer');
  minus.disabled=item.quantity<=1;plus.disabled=item.quantity>=99;
  minus.setAttribute('aria-label','Diminuer la quantité de '+(p?.variant||item.product_title));plus.setAttribute('aria-label','Augmenter la quantité de '+(p?.variant||item.product_title));output.setAttribute('aria-label','Quantité');
  minus.onclick=()=>changeQuantity(item,-1);plus.onclick=()=>changeQuantity(item,1);removeButton.onclick=()=>remove(item);removeButton.setAttribute('aria-label','Retirer '+(p?.variant||item.product_title));
  counter.append(minus,output,plus);controls.append(counter,removeButton);content.append(heading,variant);
  for(const discount of item.line_level_discount_allocations||[])content.append(el('p','cart-discount',discount.discount_application.title+' : −'+money(discount.amount)));
  content.append(controls);li.append(img,content);list.append(li);
 }
 $('.cart-subtotal').textContent=money(cart.items_subtotal_price??cart.total_price);$('.cart-total').textContent=money(cart.total_price);
 updateCheckout();
 const complement=['orange','oriental'].find(id=>catalog[id].available&&!cart.items.some(i=>i.variant_id===catalog[id].variantId));
 $('.cart-complement').hidden=!n||!complement;
 if(complement){const p=catalog[complement];$('.complement-product img').src=p.image;$('.complement-product img').alt=p.variant;$('#complement-title').textContent=p.variant;$('#add-complement').dataset.id=complement;$('#add-complement').setAttribute('aria-label','Ajouter '+p.variant);$('.complement-price').textContent=amount(complement)+' TTC';}
}
$('#undo-remove').onclick=async()=>{if(!removed)return;const saved=removed;await mutate(()=>request('cart/add.js',{items:[{id:saved.variantId,quantity:saved.quantity,properties:saved.properties,...(saved.sellingPlan?{selling_plan:saved.sellingPlan}:{})}]}),'Article remis dans le panier.',()=>{removed=null;$('.cart-undo').hidden=true;$('#cart-title').focus();});};
$('#add-complement').onclick=e=>add(e.currentTarget.dataset.id);
$('.az-selection-button').onclick=async()=>{show('cart');if(!busy){try{await refresh();$('.cart-error').hidden=true;}catch{loaded=false;$('#checkout-button').disabled=true;error('Le panier n’a pas pu être chargé. Ouvrez la page panier ou réessayez.');}}};
$('#empty-discover').onclick=()=>{close('cart');if($('#az-collection'))scrollTo($('#az-collection'));else location.href=theme.root+'#az-collection';};

 // La description et les rubriques du popup proviennent du produit Shopify sélectionné.
 const deliveryDetails = `<details><summary>Livraison & retours</summary><p>Mondial Relay, La Poste ou remise en main propre à Marseille. Les frais de livraison sont calculés et affichés avant paiement.
 Rétractation : 14 jours ; exception applicable aux biens descellés ne pouvant être renvoyés pour des raisons de santé ou d’hygiène. <a href="${theme.deliveryUrl}">Lire les conditions</a>.</p></details>`;
 function renderProductDescription(p){
  const description=$('.variant-description'),accordions=$('.product-accordions');
  description.replaceChildren();accordions.replaceChildren();
  const content=document.createElement('template');
  content.innerHTML=typeof p.description==='string'?p.description:'';
  let destination=description,sectionTitle='';
  for(const node of [...content.content.childNodes]){
   if(node.nodeType===1&&/^H[1-6]$/.test(node.tagName)){
    const details=document.createElement('details'),summary=document.createElement('summary');
    details.open=true;sectionTitle=node.textContent.trim().toLocaleLowerCase('fr');
    if(node.id)summary.id=node.id;
    summary.append(...node.childNodes);details.append(summary);accordions.append(details);destination=details;
   }else{
    if(node.nodeType===1){
     if(sectionTitle.includes('rituel')){
      if(node.matches('ol'))node.classList.add('ritual-steps');
      node.querySelectorAll('ol').forEach(list=>list.classList.add('ritual-steps'));
     }
     if(sectionTitle.includes('allergène')&&node.matches('p'))node.classList.add('allergens');
    }
    destination.append(node);
   }
  }
  if(p.family==='oil'||SERUM_EN_VENTE)accordions.insertAdjacentHTML('beforeend',deliveryDetails);
 }
 // Galerie : photos de la fiche produit active, chargées une seule fois.
 const galleryCache = new Map();
 let galleryOwner = null;
 let galleryIndex = 0;
 let galleryImages = [];
 let galleryControls = null;
 let galleryPrevious = null;
 let galleryNext = null;
 let galleryCounter = null;

 function setupProductGallery() {
  const container = $('.product-gallery');
  if (!container) return;
  if (galleryControls && container.contains(galleryControls)) return;
  galleryControls = container.querySelector('.gallery-options');
  if (!galleryControls) {
   galleryControls = document.createElement('div');
   galleryControls.className = 'gallery-options';
   container.append(galleryControls);
  }
  galleryControls.replaceChildren();
  galleryControls.setAttribute('role', 'group');
  galleryControls.setAttribute('aria-label', 'Photos du produit');
  galleryPrevious = document.createElement('button');
  galleryPrevious.type = 'button';
  galleryPrevious.textContent = '←';
  galleryPrevious.setAttribute('aria-label', 'Photo précédente');
  galleryPrevious.setAttribute('aria-controls', 'product-image');
  galleryNext = document.createElement('button');
  galleryNext.type = 'button';
  galleryNext.textContent = '→';
  galleryNext.setAttribute('aria-label', 'Photo suivante');
  galleryNext.setAttribute('aria-controls', 'product-image');
  galleryCounter = document.createElement('span');
  galleryCounter.setAttribute('aria-live', 'polite');
  galleryCounter.setAttribute('aria-atomic', 'true');
  galleryCounter.style.cssText = 'display:flex;align-items:center;justify-content:center;min-width:64px;padding:0 10px;background:#f5f1e8;color:#243c30;font-size:12px;';
  for (const button of [galleryPrevious, galleryNext]) {
   button.style.cssText = 'min-width:48px;min-height:48px;font-size:24px;line-height:1;color:#243c30;background:#f5f1e8;border:1px solid #b5beac;cursor:pointer;';
  }
  galleryControls.style.zIndex = '2';
  galleryPrevious.addEventListener('click', () => moveProductGallery(-1));
  galleryNext.addEventListener('click', () => moveProductGallery(1));
  galleryControls.append(galleryPrevious, galleryCounter, galleryNext);
 }

 let photoZoom = null;
 let zoomImage = null;
 let zoomCount = null;
 let zoomPrevious = null;
 let zoomNext = null;
 let zoomOpener = null;

 function ensurePhotoZoom() {
  if (photoZoom) return;
  photoZoom = document.createElement('dialog');
  photoZoom.setAttribute('aria-label', 'Photo du produit en grand');
  photoZoom.style.cssText = 'position:fixed;inset:0;width:100vw;max-width:100vw;height:100dvh;max-height:100dvh;margin:0;padding:0;border:0;background:#f5f1e8;color:#243c30;overflow:hidden;';
  const layout = document.createElement('div');
  layout.style.cssText = 'height:100%;display:grid;grid-template-rows:60px minmax(0,1fr) 72px;';
  const header = document.createElement('div');
  header.style.cssText = 'display:flex;justify-content:flex-end;align-items:center;padding:6px 16px;';
  const closeButton = document.createElement('button');
  closeButton.type = 'button';
  closeButton.textContent = '×';
  closeButton.setAttribute('aria-label', 'Fermer la photo agrandie');
  closeButton.style.cssText = 'width:48px;height:48px;font-size:32px;background:transparent;border:1px solid #b5beac;color:#243c30;cursor:pointer;';
  closeButton.onclick = () => photoZoom.close();
  header.append(closeButton);
  zoomImage = document.createElement('img');
  zoomImage.style.cssText = 'display:block;position:static;width:100%;height:100%;max-width:100%;max-height:100%;object-fit:contain;padding:0 12px;box-sizing:border-box;';
  const footer = document.createElement('div');
  footer.style.cssText = 'display:flex;justify-content:center;align-items:center;gap:8px;';
  zoomPrevious = document.createElement('button');
  zoomNext = document.createElement('button');
  zoomCount = document.createElement('span');
  zoomCount.setAttribute('aria-live', 'polite');
  zoomCount.setAttribute('aria-atomic', 'true');
  zoomCount.style.cssText = 'min-width:68px;text-align:center;font-size:14px;';
  for (const [button, direction, label, symbol] of [[zoomPrevious,-1,'Photo précédente','←'],[zoomNext,1,'Photo suivante','→']]) {
   button.type = 'button';
   button.textContent = symbol;
   button.setAttribute('aria-label', label);
   button.style.cssText = 'min-width:48px;min-height:48px;font-size:24px;background:transparent;border:1px solid #b5beac;color:#243c30;cursor:pointer;';
   button.onclick = () => moveProductGallery(direction);
  }
  footer.append(zoomPrevious, zoomCount, zoomNext);
  layout.append(header, zoomImage, footer);
  photoZoom.append(layout);
  document.body.append(photoZoom);
  photoZoom.addEventListener('keydown', event => {
   if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
    event.preventDefault();
    moveProductGallery(event.key === 'ArrowLeft' ? -1 : 1);
   }
  });
  photoZoom.addEventListener('close', () => {
   lock();
   if (zoomOpener && zoomOpener.isConnected && dialogs.product.open) zoomOpener.focus();
  });
 }

 function openPhotoZoom() {
  ensurePhotoZoom();
  zoomOpener = $('#product-image');
  updatePhotoZoom();
  if (!photoZoom.open) photoZoom.showModal();
  lock();
 }

 function updatePhotoZoom() {
  if (!photoZoom || !zoomImage) return;
  const p = catalog[active];
  const source = galleryImages[galleryIndex] || p.image;
  if (source && zoomImage.getAttribute('src') !== source) zoomImage.src = source;
  zoomImage.alt = p.title + ' · ' + p.variant + ' · Photo ' + (galleryIndex + 1);
  zoomCount.textContent = (galleryIndex + 1) + ' / ' + Math.max(1, galleryImages.length);
  zoomPrevious.hidden = galleryImages.length < 2;
  zoomNext.hidden = galleryImages.length < 2;
 }

 function paintProductGallery() {
  setupProductGallery();
  const image = $('#product-image');
  if (!image || !galleryControls) return;
  const p = catalog[active];
  const source = galleryImages[galleryIndex] || p.image;
  if (source && image.getAttribute('src') !== source) image.src = source;
  image.alt = p.title + ' · ' + p.variant + ' · Photo ' + (galleryIndex + 1);
  const multiple = galleryImages.length > 1;
  galleryControls.hidden = !multiple;
  galleryControls.style.display = multiple ? 'flex' : 'none';
  galleryPrevious.disabled = !multiple;
  galleryNext.disabled = !multiple;
  galleryCounter.textContent = (galleryIndex + 1) + ' / ' + Math.max(1, galleryImages.length);
  // Les commandes occupent leur propre bandeau, hors de la photo.
  galleryControls.style.cssText = 'position:absolute;left:0;right:0;bottom:0;height:64px;display:' + (multiple ? 'flex' : 'none') + ';justify-content:center;align-items:center;gap:6px;background:#f5f1e8;z-index:2;';
  image.style.height = multiple ? 'calc(100% - 64px)' : '100%';
  image.style.bottom = 'auto';
  image.style.cursor = 'zoom-in';
  image.setAttribute('tabindex', '0');
  image.setAttribute('role', 'button');
  image.setAttribute('aria-label', 'Agrandir la photo ' + (galleryIndex + 1) + ' de ' + p.variant);
  image.onclick = openPhotoZoom;
  image.onkeydown = event => {
   if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    openPhotoZoom();
   }
  };
  updatePhotoZoom();
 }

 function moveProductGallery(direction) {
  if (galleryImages.length < 2) return;
  galleryIndex = (galleryIndex + direction + galleryImages.length) % galleryImages.length;
  paintProductGallery();
 }

 function loadProductGallery() {
  const id = active;
  const p = catalog[id];
  const identity = id + ':' + (p.productId || '') + ':' + (p.url || '');
  if (galleryOwner === identity) {
   paintProductGallery();
   return;
  }
  galleryOwner = identity;
  galleryIndex = 0;
  galleryImages = p.image ? [p.image] : [];
  paintProductGallery();
  if (!p.url) return;
  let productUrl;
  try {
   productUrl = new URL(p.url, location.origin);
   if (productUrl.origin !== location.origin) return;
   productUrl.pathname = productUrl.pathname.replace(/\/$/, '').replace(/\.js$/, '') + '.js';
   productUrl.search = '';
   productUrl.hash = '';
  } catch { return; }
  const key = productUrl.href;
  if (!galleryCache.has(key)) {
   const controller = new AbortController();
   const timeout = setTimeout(() => controller.abort(), 12000);
   const pending = fetch(key, {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' },
    signal: controller.signal
   }).then(response => {
    if (!response.ok) throw new Error('Photos indisponibles');
    return response.json();
   }).then(data => {
    if (p.productId && String(data.id) !== String(p.productId)) throw new Error('Produit différent');
    if (!Array.isArray(data.images)) throw new Error('Galerie indisponible');
    const images = data.images.map(item => typeof item === 'string' ? item : item && item.src)
     .filter(source => typeof source === 'string')
     .map(source => {
      try {
       const url = new URL(source, location.origin);
       return url.protocol === 'https:' ? url.href : null;
      } catch { return null; }
     }).filter(Boolean);
    return [...new Set(images)];
   }).catch(error => {
    galleryCache.delete(key);
    throw error;
   }).finally(() => clearTimeout(timeout));
   galleryCache.set(key, pending);
  }
  galleryCache.get(key).then(images => {
   if (galleryOwner !== identity || active !== id) return;
   galleryImages = images.length ? images : (p.image ? [p.image] : []);
   galleryIndex = 0;
   paintProductGallery();
  }).catch(() => {
   if (galleryOwner !== identity || active !== id) return;
   // Conserver la photo de secours, sans mélanger les produits.
   paintProductGallery();
  });
 }

 function renderProduct(resetDetails=true){const states=resetDetails?null:$$('.product-accordions details').map(d=>d.open);
  const p=catalog[active],oil=p.family==='oil',coming=!oil&&!SERUM_EN_VENTE;
  $('#product-category').textContent=oil?'LES PARFUMS DE LA MAISON':'LE RITUEL DE SOIN';
  $('#product-title').textContent=oil?p.variant:p.title;
  $('#product-subtitle').textContent=oil?'Huile à brûler parfumée · 50 ml':'L’or précieux de la nature';
  $('.product-price-line').hidden=coming;
renderCatalogPrice($('.product-price'), active);
  $('.price-context').hidden=false;
  $('.price-context').textContent=oil?'50 ml · Brûleur non inclus':'Contenance : 10 ml';
  $('.scent-title').hidden=!oil;$('.variant-options').hidden=!oil;
  $$('[data-variant]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.variant===active)));
  renderProductDescription(p);
  $('.product-context').textContent = oil
  ? 'Brûleur non inclus. Votre parfum et votre quantité restent modifiables dans le panier.'
  : '';
  $('.serum-notify').hidden=!coming;
  $('.buy-row').hidden=coming;
  $('.product-context').hidden=coming||!oil;
  if(states)$$('.product-accordions details').forEach((d,i)=>d.open=states[i]??d.open);
  loadProductGallery();
  $('#product-qty').value=String(qty);$('#product-qty').textContent=String(qty);
  $('.product-minus').disabled=qty<=1;$('.product-plus').disabled=qty>=99;$('#product-add').disabled=!p.available;$('#product-add').textContent=p.available?'Ajouter au panier':'Bientôt disponible';
 }
 function product(id){active=id;qty=1;view='ambiance';renderProduct();show('product');}

 // Ouverture de la fiche produit : délégation d’événements en phase de capture.
 document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-product]');
  if (!button) return;

  const productId = {
    oil: 'oriental',
    oriental: 'oriental',
    orange: 'orange',
    serum: 'serum'
  }[button.dataset.product];

  if (!productId) {
    console.warn('[Al Azhar] data-product inconnu :', button.dataset.product);
    return;
  }

  event.preventDefault();

  try {
    product(productId);
  } catch (err) {
    console.error('[Al Azhar] Impossible d’ouvrir la fiche produit :', err);
  }
 }, true);

 $$('[data-variant]').forEach(b=>b.onclick=()=>{active=b.dataset.variant;view='ambiance';renderProduct();});
 $$('[data-view]').forEach(b=>b.onclick=()=>{view=b.dataset.view;renderProduct(false);});
 $('.product-minus').onclick=()=>{qty=Math.max(1,qty-1);renderProduct(false);};$('.product-plus').onclick=()=>{qty=Math.min(99,qty+1);renderProduct(false);};
 $('#product-add').onclick=()=>add(active,qty);
 const scenes={water:{image:theme.assets.water,title:'L’art de<br><em>ralentir.</em>',description:'Un parfum qui habite la maison.<br>Un geste qui prend soin de vous.<br>Entrez dans l’univers Al Azhar.',caption:'L’HUILE À BRÛLER · ORIENTAL',alt:'Huile à brûler Oriental au-dessus d’une eau vert turquoise',color:'#f5f1e8'},sun:{image:theme.assets.orange,title:'Le goût<br><em>du soleil.</em>',description:'La chaleur d’un intérieur.<br>La lumière d’un souvenir.<br>Découvrez Fleur d’oranger.',caption:'L’HUILE À BRÛLER · FLEUR D’ORANGER',alt:'Huile Fleur d’oranger parmi des agrumes et des fleurs',color:'#efdfc7'},earth:{image:theme.assets.serum,title:'L’essence<br><em>du rituel.</em>',description:'Un instant pour vous.<br>Un geste à retrouver chaque jour.<br>Découvrez l’Élixir royal.',caption:'LE SOIN · ÉLIXIR ROYAL DE JEUNESSE',alt:'Élixir royal de jeunesse parmi des figues de Barbarie',color:'#e6e8db'}};
 $$('.az-scene').forEach(b=>b.onclick=()=>{const s=scenes[b.dataset.scene];$('.az-hero-photo').src=s.image;$('.az-hero-photo').alt=s.alt;$('.az-hero h1').innerHTML=s.title;$('.az-hero-description').innerHTML=s.description;$('.az-photo-caption').textContent=s.caption;$('.az-hero').style.background=s.color;$$('.az-scene').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));});
// Scènes automatiques : 15 secondes ; pause de 30 secondes après un clic.
(() => {
  const hero = document.querySelector('.az-hero');
  if (!hero) return;

  const buttons = ['water', 'sun', 'earth'].map(scene =>
    hero.querySelector(`.az-scene[data-scene="${scene}"]`)
  );
  if (buttons.some(button => !button)) return;

  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const elements = [
    hero.querySelector('.az-hero-photo'),
    hero.querySelector('h1'),
    hero.querySelector('.az-hero-description'),
    hero.querySelector('.az-photo-caption')
  ].filter(Boolean);

  let timer;
  let automaticClick = false;
  let animations = [];
  let transitionId = 0;
  let pausedUntil = 0;

  function cancelTransition() {
    transitionId++;
    animations.forEach(animation => animation.cancel());
    animations = [];
  }

  function schedule(delay) {
    clearTimeout(timer);
    // Pas de défilement automatique en mode animations réduites.
    if (motion.matches) return;
    timer = setTimeout(nextScene, delay);
  }

  async function nextScene() {
    if (motion.matches) return;

    const remainingPause = pausedUntil - Date.now();
    if (remainingPause > 0) {
      schedule(remainingPause);
      return;
    }

    cancelTransition();
    const currentTransition = transitionId;
    const current = buttons.findIndex(
      button => button.getAttribute('aria-pressed') === 'true'
    );
    const next = buttons[(current + 1) % buttons.length];
    schedule(15000);

    try {
      animations = elements.map(element =>
        element.animate(
          [{ opacity: 1 }, { opacity: 0 }],
          { duration: 250, easing: 'ease-in', fill: 'forwards' }
        )
      );
      await Promise.all(animations.map(animation => animation.finished));

      if (currentTransition !== transitionId || motion.matches) return;

      // Réutilise le gestionnaire existant : image, textes et bouton actif.
      automaticClick = true;
      try {
        next.click();
      } finally {
        automaticClick = false;
      }

      animations.forEach(animation => animation.cancel());
      animations = elements.map(element =>
        element.animate(
          [{ opacity: 0 }, { opacity: 1 }],
          { duration: 400, easing: 'ease-out' }
        )
      );
      await Promise.all(animations.map(animation => animation.finished));
      if (currentTransition === transitionId) animations = [];
    } catch {
      // Une interaction manuelle peut annuler la transition en cours.
    }
  }

  buttons.forEach(button => {
    button.addEventListener('click', () => {
      if (automaticClick) return;
      cancelTransition();
      pausedUntil = Date.now() + 30000;
      schedule(30000);
    });
  });

  motion.addEventListener('change', () => {
    clearTimeout(timer);
    cancelTransition();
    if (!motion.matches) {
      schedule(Math.max(15000, pausedUntil - Date.now()));
    }
  });

  schedule(15000);
})();

 $$('.az-filter').forEach(b=>b.onclick=()=>{$$('[data-category]').forEach(p=>p.hidden=b.dataset.filter!=='all'&&p.dataset.category!==b.dataset.filter);$$('.az-filter').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));});
 const media=$('.az-hero-media');media?.addEventListener('pointermove',e=>{if(reduced()||e.pointerType==='touch')return;const r=media.getBoundingClientRect();$('.az-hero-photo').style.transform=`scale(1.045) translate(${((e.clientX-r.left)/r.width-.5)*7}px,${((e.clientY-r.top)/r.height-.5)*7}px)`;});media?.addEventListener('pointerleave',()=>$('.az-hero-photo').style.transform='scale(1.03)');
 if(!reduced()&&'IntersectionObserver'in window){const io=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.remove('az-below');io.unobserve(e.target);}}),{threshold:.06});$$('.az-reveal').forEach(e=>{if(e.getBoundingClientRect().top>innerHeight)e.classList.add('az-below');io.observe(e);});}

// Prix des cartes liés aux fiches produits Shopify.
if (SERUM_EN_VENTE) {
 $$('[data-serum-collection-price]').forEach(node => {
  renderCatalogPrice(node, 'serum', ' TTC par flacon');
 });
}
$$('.serum-availability').forEach(n=>n.textContent=SERUM_EN_VENTE?amount('serum')+' TTC':'Bientôt disponible');
$$('.serum-collection-signup').forEach(n=>n.hidden=SERUM_EN_VENTE);
const collectionOilIds = ['oriental', 'orange'].filter(id => {
 const p = catalog[id];
 return p.productId && p.variantId && Number.isSafeInteger(p.price) && p.price >= 0;
});
$$('[data-collection-prices]').forEach(node => {
 node.replaceChildren();
 if (!collectionOilIds.length) {
  node.textContent = 'Prix indisponible';
  return;
 }
 collectionOilIds.forEach(id => {
  const row = el('span', 'az-oil-price-row');
  const prices = el('span', 'az-oil-price-values');
  row.append(el('span', 'az-oil-price-name', catalog[id].variant + ' : '));
  renderCatalogPrice(prices, id, ' TTC par flacon');
  row.append(prices);
  node.append(row);
 });
});
if(SERUM_EN_VENTE){const faq=$('.faq-serum-status');if(faq)faq.textContent='Élixir royal de jeunesse : '+amount('serum')+'.';const cgv=$('.cgv-serum-status');if(cgv)cgv.textContent='Élixir royal de jeunesse : '+amount('serum')+'.';}
renderCart();refresh().catch(()=>{loaded=false;error('Le panier est temporairement indisponible. Vous pouvez ouvrir la page panier.');});
window.addEventListener('pageshow',e=>{if(e.persisted&&!busy)refresh().catch(()=>{});});
document.addEventListener('visibilitychange',()=>{if(!document.hidden&&!busy)refresh().catch(()=>{});});
})();